// extracted by mini-css-extract-plugin
export default {"timer":"forgot-password_timer__6P3Yv","button":"forgot-password_button__9H-du","returnBack":"forgot-password_returnBack__-WrQD","resendBtn":"forgot-password_resendBtn__8jU4F"};